import { render } from "./LoginPageV2.vue?vue&type=template&id=594e6692"
import script from "./LoginPageV2.vue?vue&type=script&lang=js"
export * from "./LoginPageV2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__